import { memo } from "react";

import { NavBar } from "~/components/navBar/NavBar";

import type { ReactNode } from "react";

export interface NotebookViewMainHeaderProps {
  children?: ReactNode;
}

export const NotebookViewMainHeader = memo(function NotebookViewMainHeader({
  children,
}: NotebookViewMainHeaderProps) {
  return (
    <div className="NotebookViewMainHeader">
      <NavBar>{children}</NavBar>
    </div>
  );
});
